// extracted by mini-css-extract-plugin
module.exports = {"icon":"loader_icon__BDriF","wrapperLoader":"loader_wrapperLoader__yX2Km","button_loader":"loader_button_loader__6apag"};